import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a1e8406"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-lg" }, null, -1))
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "panel-container" }
const _hoisted_4 = { class: "main-panel" }
const _hoisted_5 = {
  key: 0,
  class: "job-header"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"title-section\" data-v-4a1e8406><div class=\"skeleton-title\" data-v-4a1e8406></div><div class=\"skeleton-subtitle\" data-v-4a1e8406></div></div><div class=\"header-actions\" data-v-4a1e8406><div class=\"skeleton-status\" data-v-4a1e8406></div><div class=\"skeleton-menu\" data-v-4a1e8406></div></div>", 2)
const _hoisted_8 = [
  _hoisted_6
]
const _hoisted_9 = {
  key: 1,
  class: "meta-info"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-icon" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-text" }, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "job-header" }
const _hoisted_14 = { class: "title-section" }
const _hoisted_15 = { class: "job-title-container" }
const _hoisted_16 = { class: "job-title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-link m-2" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "company-name" }
const _hoisted_20 = { class: "header-actions" }
const _hoisted_21 = {
  key: 0,
  class: "status-dropdown"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "actions-menu"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots-vertical" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 0,
  class: "actions-dropdown"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_28 = { class: "meta-info" }
const _hoisted_29 = { class: "meta-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt" }, null, -1))
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "meta-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar" }, null, -1))
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "meta-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cash" }, null, -1))
const _hoisted_37 = {
  key: 0,
  class: "salary-input"
}
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "meta-item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-building" }, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Remote", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "On-site", -1))
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "job-description" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Company Description", -1))
const _hoisted_47 = { class: "company-description-content" }
const _hoisted_48 = {
  key: 0,
  class: "description-text"
}
const _hoisted_49 = {
  key: 1,
  class: "empty-description"
}
const _hoisted_50 = { class: "job-description" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Job Description", -1))
const _hoisted_52 = { class: "description-content job-description-content" }
const _hoisted_53 = {
  key: 0,
  class: "description-text"
}
const _hoisted_54 = {
  key: 1,
  class: "empty-description"
}
const _hoisted_55 = { class: "tools-and-analysis-panel" }
const _hoisted_56 = { class: "tools-panel" }
const _hoisted_57 = { class: "tools-grid" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 0,
  class: "coming-soon"
}
const _hoisted_60 = {
  key: 1,
  class: "new-tag"
}
const _hoisted_61 = {
  key: 0,
  class: "analysis-section"
}
const _hoisted_62 = {
  key: 0,
  class: "match-analysis"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))
const _hoisted_64 = {
  key: 1,
  class: "splash-screen"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-up-arrow text-primary" })
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-content" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Analyze Your Match"),
  /*#__PURE__*/_createElementVNode("p", null, "See how well your profile aligns with this role's requirements")
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Legend,
  ArcElement,
} from "chart.js";
import { useRoute, useRouter } from "vue-router";
import store from "@/store";
import { ref, computed, onMounted } from "vue";
import { ApplicationApiService } from "@/services/ApplicationApiService";
import CreateOrUpdateApplication from "@models/dtos/CreateOrUpdateApplication";
import { ApplicationStatus } from "@models/SystemEnums";
import { ResponseApiService } from "@/services/ResponseApiService";
import { ResponseDto } from "@models/dtos/ResponseDtos";
import { ResponseType } from "@models/Response";
import { ResumeFeedbackOutput, MatchData } from "../models/dtos/ResumeFeedbackOutput";
import JobMatchRadarChart from "@/components/JobMatchRadarChart.vue";
import confetti from "canvas-confetti";

interface RadarChartData {
  labels: string[];
  datasets: {
    data: number[];
    backgroundColor: string;
    borderColor: string;
    borderWidth: number;
    pointBackgroundColor: string;
    pointBorderColor: string;
    pointHoverBackgroundColor: string;
    pointHoverBorderColor: string;
  }[];
}

// Add this with the other refs

export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationView',
  setup(__props) {

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Legend, ArcElement);
ChartJS.defaults.font.size = 16;

const showFullDescription = ref(false);
const toggleDescription = () => {
  showFullDescription.value = !showFullDescription.value;
};
const application = ref<CreateOrUpdateApplication>({
  id: null,
  userId: "",
  companyName: "",
  roleTitle: "",
  jobDescription: "",
  companyDescription: "",
  roleComments: "",
  applicationStatus: ApplicationStatus.APPLIED,
  index: 0,
  location: "",
  postedDate: "",
  salary: "",
  maxSalary: "",
  sourcedFrom: "",
  jobUrl: "",
  isRemote: false,
});

const route = useRoute();
const router = useRouter();
const showResumeAnalysis = ref(false);
const applicationResponses = ref<ResponseDto[] | null>(null);

// Add loading state
const loading = ref(true);

// Update the onMounted hook
onMounted(async () => {
  store.dispatch("toggleLoader", true);
  loading.value = true;
  await loadApplication();
  loading.value = false;
  store.dispatch("toggleLoader", false);
});

async function loadApplication() {
  const applicationId = route.params.id as string;
  const response = await ApplicationApiService.getApplicationById(applicationId);
  if (response.status == 200) {
    application.value = await response.data;
    application.value.id = applicationId;
    applicationResponses.value = (
      await ResponseApiService.getApplicationResponses(applicationId)
    ).data;
  }
}

function getFormattedDate(dateString: string) {
  if (!dateString) return "N/A";
  // Handle MM/DD/YYYY format
  if (dateString.includes("/")) {
    const [month, day, year] = dateString.split("/");
    dateString = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
}

function getShortLocation(location: string) {
  return location?.split(",")[0].trim();
}

function openCoverLetterGenerator(): void {
  const coverLetterResponse = applicationResponses.value?.find(
    (r) => r.type === ResponseType.CoverLetter
  );
  if (coverLetterResponse?.id) {
    router.push({
      name: "CoverLetterGenerator",
      params: {
        id: route.params.id,
        documentId: coverLetterResponse.id
      }
    });
  } else {
    router.push({
      name: "CoverLetterGenerator",
      params: {
        id: route.params.id,
        documentId: "new"
      },
      query: {
        type: "coverLetter"
      }
    });
  }
}

function openResumeGenerator(): void {
  const resumeResponse = applicationResponses.value?.find(
    (r) => r.type === ResponseType.CreateResume
  );
  if (resumeResponse?.id) {
    router.push(`/application/${route.params.id}/resume/${resumeResponse.id}`);
  } else {
    router.push({
      name: "AIResumeEditorWithoutResume",
      params: {
        applicationId: route.params.id
      }
    });
  }
}

function getIconForJobSite(jobSite: string) {
  jobSite = jobSite.toLowerCase();
  switch (jobSite) {
    case "indeed":
      return require("../../public/media/icons/indeed.svg");
    case "linkedin":
      return require("../../public/media/icons/linkedin.svg");
    case "glassdoor":
      return require("../../public/media/icons/glassdoor.svg");
    case "zip_recruiter":
      return require("../../public/media/icons/zip.svg");
    default:
      return "";
  }
}

function openUrl(url: string) {
  window.open(url, "_blank");
}

function createDocument(type: string) {
  if (type === "coverLetter") {
    router.push(`/application/${route.params.id}/documents?newCoverLetter=true`);
  }
  // ... handle other document types
}

const aiTools = [
  {
    name: "Cover Letter",
    icon: "bi bi-file-text",
    action: openCoverLetterGenerator,
  },
  {
    name: "Email Generator",
    icon: "bi bi-envelope",
    action: () => {
      router.push({
        name: "EmailGenerator",
      });
    },
  },
  {
    name: "Resume Optimizer",
    icon: "bi bi-file-earmark-text",
    action: openResumeGenerator,
    isNew: true,
  },
  {
    name: "Interview Prep",
    icon: "bi bi-person-video",
    action: () => {
      router.push(`/application/${route.params.id}/interview-prep`);
    },
  },
  {
    name: "Interview Practice",
    icon: "bi bi-camera-video",
    action: () => {
      router.push(`/application/${route.params.id}/interview-practice`);
    },
  },
  {
    name: "LinkedIn Message",
    icon: "bi bi-linkedin",
    action: () => {
      console.log("");
    },
    disabled: true,
    comingSoon: true,
  },
];

// Add this function to format the enum value
function formatApplicationStatus(status: ApplicationStatus | string): string {
  if (typeof status === "string") {
    return status
      .split("_")
      .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
      .join(" ");
  }
  return ApplicationStatus[status]
    .split("_")
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ");
}

const showStatusDropdown = ref(false);

// Create a computed array of unique statuses
const applicationStatuses = computed(() => [
  ApplicationStatus.TO_APPLY,
  ApplicationStatus.APPLIED,
  ApplicationStatus.INTERVIEWING,
  ApplicationStatus.REJECTED,
  ApplicationStatus.OFFERED,
]);

const updateStatus = async (newStatus: ApplicationStatus) => {
  application.value.applicationStatus = newStatus;
  showStatusDropdown.value = false;

  if (newStatus === ApplicationStatus.OFFERED) {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 1 },
    });
  }
  try {
    await ApplicationApiService.createOrUpdateApplication(application.value);
  } catch (error) {
    console.error("Failed to update application status:", error);
    await loadApplication();
  }
};

// Click outside to close dropdown
onMounted(() => {
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".status-badge")) {
      showStatusDropdown.value = false;
    }
  });
});

const getStatusClass = (status: ApplicationStatus) => {
  const statusClasses = {
    [ApplicationStatus.TO_APPLY]: "to-apply",
    [ApplicationStatus.APPLIED]: "applied",
    [ApplicationStatus.INTERVIEWING]: "interviewing",
    [ApplicationStatus.REJECTED]: "rejected",
    [ApplicationStatus.OFFERED]: "offered",
  };
  return statusClasses[status];
};

// Add this new function to handle saving changes
const saveChanges = async () => {
  try {
    await ApplicationApiService.createOrUpdateApplication(application.value);
  } catch (error) {
    console.error("Failed to save changes:", error);
    await loadApplication(); // Reload original data if save fails
  }
};

const isEditing = ref(false);
const showActionsMenu = ref(false);

const toggleEditMode = () => {
  if (isEditing.value) {
    saveChanges();
  }
  isEditing.value = !isEditing.value;
  showActionsMenu.value = false;
};

const deleteApplication = async () => {
  if (confirm("Are you sure you want to delete this application?")) {
    try {
      await ApplicationApiService.deleteApplication(application.value.id);
      router.push("/applications");
    } catch (error) {
      console.error("Failed to delete application:", error);
    }
  }
};

const formatSalary = (
  currency: string,
  min: number | string,
  max: number | string,
  interval: string
) => {
  const getCurrencySymbol = (currency: string) => {
    return currency === "USD"
      ? "$"
      : currency === "EUR"
      ? "€"
      : currency === "GBP"
      ? "£"
      : currency;
  };
  if (!min && !max) {
    return "N/A";
  }

  const formattedNumber = (num: number | string) => {
    num = parseFloat(num.toString().replace(/[^\d.]/g, "")).toLocaleString();
    return num;
  };

  if (!max) {
    return `< ${getCurrencySymbol(currency)}${formattedNumber(min)} ${interval || "y"}`;
  } else if (!min) {
    return `> ${getCurrencySymbol(currency)}${formattedNumber(max)} ${interval || "y"}`;
  }
  return `${getCurrencySymbol(currency)}${formattedNumber(min)}-${formattedNumber(max)} ${
    interval || "y"
  }`;
};

const matchAnalysis = ref<ResumeFeedbackOutput | null>(null);
// Modify the existing click outside handler
onMounted(async () => {
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    if (!target.closest(".status-badge")) {
      showStatusDropdown.value = false;
    }
    if (!target.closest(".actions-menu")) {
      showActionsMenu.value = false;
    }
  });
  const applicationId = route.params.id as string;
  matchAnalysis.value = (
    await ApplicationApiService.getApplicationAnalysisById(applicationId)
  ).data;
});

const openAdvancedAnalysis = () => {
  router.push(`/application/${route.params.id}/match-analysis`);
};

const getRadarChartData = (analysis: ResumeFeedbackOutput) => {
  // Calculate percentages
  const calculatePercentage = (data: { term: string; included: boolean }[] | undefined) => {
    if (!data || !Array.isArray(data) || data.length === 0) return null;
    const includedCount = data.filter((item) => item.included).length;
    return Math.round((includedCount / data.length) * 100);
  };

  // Calculate all matches
  const culturalMatch = calculatePercentage(analysis.culturalMatchData);
  const skillsMatch = calculatePercentage(analysis.skillMatchData);
  const experienceMatch = calculatePercentage(analysis.experienceMatchData);
  const keywordMatch = calculatePercentage(analysis.keywordMatchData);
  const educationMatch = analysis.educationMatchData?.term
    ? analysis.educationMatchData.included
      ? 100
      : 0
    : null;

  // Create data array in same order as labels
  const data = [
    culturalMatch ?? 0, // If null (N/A), show as 0
    educationMatch ?? 0, // If null (N/A), show as 0
    experienceMatch ?? 0,
    keywordMatch ?? 0, // If null (N/A), show as 0
    skillsMatch ?? 0,
  ];

  return {
    labels: ["Cultural", "Education", "Experience", "Keyword", "Skills"],
    datasets: [
      {
        data,
        backgroundColor: "rgba(13, 110, 253, 0.2)",
        borderColor: "#0d6efd",
        borderWidth: 2,
        pointBackgroundColor: "#0d6efd",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#0d6efd",
      },
    ],
  };
};

// Update the onMounted hook to transform the data
onMounted(async () => {
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    if (!target.closest(".status-badge")) {
      showStatusDropdown.value = false;
    }
    if (!target.closest(".actions-menu")) {
      showActionsMenu.value = false;
    }
  });
  const applicationId = route.params.id as string;
  const analysisResponse = await ApplicationApiService.getApplicationAnalysisById(applicationId);
  if (analysisResponse.data) {
    matchAnalysis.value = analysisResponse.data;
    radarChartData.value = getRadarChartData(analysisResponse.data);
  }
});

const radarChartData = ref<RadarChartData | null>(null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["application-container", { editing: isEditing.value }])
  }, [
    (isEditing.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "editing-button",
          onClick: toggleEditMode
        }, [
          _hoisted_1,
          _createTextVNode(" Finished Editing ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
            : _createCommentVNode("", true),
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                  return _createElementVNode("div", {
                    key: `meta-skeleton-${i}`,
                    class: "meta-item"
                  }, _hoisted_12)
                }), 64))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    (isEditing.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((application.value.roleTitle) = $event)),
                            class: "editable-title",
                            onChange: saveChanges
                          }, null, 544), [
                            [_vModelText, application.value.roleTitle]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((application.value.companyName) = $event)),
                            class: "editable-subtitle",
                            onChange: saveChanges
                          }, null, 544), [
                            [_vModelText, application.value.companyName]
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("span", _hoisted_15, [
                            _createElementVNode("h1", _hoisted_16, _toDisplayString(application.value.roleTitle), 1),
                            _createElementVNode("div", {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (openUrl(application.value.jobUrl))),
                              style: {"cursor":"pointer"},
                              class: "flex justify-center items-center"
                            }, _hoisted_18)
                          ]),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(application.value.companyName), 1)
                        ], 64))
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                    'status-badge',
                    getStatusClass(application.value.applicationStatus),
                    isEditing.value ? 'm-3' : '',
                  ])
                    }, [
                      _createElementVNode("div", {
                        class: "status-display",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (showStatusDropdown.value = !showStatusDropdown.value))
                      }, _toDisplayString(formatApplicationStatus(application.value.applicationStatus)), 1),
                      (showStatusDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applicationStatuses.value, (status) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: status,
                                class: _normalizeClass(["status-option", { active: status === application.value.applicationStatus }]),
                                onClick: ($event: any) => (updateStatus(status))
                              }, _toDisplayString(formatApplicationStatus(status)), 11, _hoisted_22))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 2),
                    (!isEditing.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("button", {
                            class: "action-button",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (showActionsMenu.value = !showActionsMenu.value))
                          }, _hoisted_25),
                          (showActionsMenu.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("div", {
                                  class: "action-option",
                                  onClick: toggleEditMode
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["bi", isEditing.value ? 'bi-check-lg' : 'bi-pencil'])
                                  }, null, 2),
                                  _createTextVNode(" " + _toDisplayString(isEditing.value ? "Save Changes" : "Edit"), 1)
                                ]),
                                _createElementVNode("div", {
                                  class: "action-option delete",
                                  onClick: deleteApplication
                                }, [
                                  _hoisted_27,
                                  _createTextVNode(" Delete ")
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    (isEditing.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((application.value.location) = $event)),
                          placeholder: "Location not specified",
                          onChange: saveChanges
                        }, null, 544)), [
                          [_vModelText, application.value.location]
                        ])
                      : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(application.value.location ? getShortLocation(application.value.location) : "N/A"), 1))
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    (isEditing.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((application.value.postedDate) = $event)),
                          placeholder: "N/A",
                          onChange: saveChanges
                        }, null, 544)), [
                          [_vModelText, application.value.postedDate]
                        ])
                      : (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(application.value.postedDate ? getFormattedDate(application.value.postedDate) : "N/A"), 1))
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    (isEditing.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((application.value.salaryCurrency) = $event)),
                            placeholder: "USD",
                            class: "currency-input",
                            onChange: saveChanges
                          }, null, 544), [
                            [_vModelText, application.value.salaryCurrency]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((application.value.salaryMin) = $event)),
                            placeholder: "Min",
                            type: "number",
                            class: "number-input",
                            onChange: saveChanges
                          }, null, 544), [
                            [_vModelText, application.value.salaryMin]
                          ]),
                          _createTextVNode(" - "),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((application.value.salaryMax) = $event)),
                            placeholder: "Max",
                            type: "number",
                            class: "number-input",
                            onChange: saveChanges
                          }, null, 544), [
                            [_vModelText, application.value.salaryMax]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((application.value.salaryInterval) = $event)),
                            placeholder: "per year",
                            class: "interval-input",
                            onChange: saveChanges
                          }, null, 544), [
                            [_vModelText, application.value.salaryInterval]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(formatSalary(
                    application.value.salaryCurrency,
                    application.value.salaryMin,
                    application.value.salaryMax,
                    application.value.salaryInterval
                  )), 1))
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    (isEditing.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((application.value.isRemote) = $event)),
                          onChange: saveChanges
                        }, _hoisted_43, 544)), [
                          [_vModelSelect, application.value.isRemote]
                        ])
                      : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(application.value.isRemote ? "Remote" : "On-site"), 1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("div", _hoisted_47, [
                    (isEditing.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                          key: 0,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((application.value.companyDescription) = $event)),
                          class: "editable-description",
                          onChange: saveChanges
                        }, null, 544)), [
                          [_vModelText, application.value.companyDescription]
                        ])
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (application.value.companyDescription)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(application.value.companyDescription), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_49, "No company description provided"))
                        ], 64))
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, [
                    (isEditing.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                          key: 0,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((application.value.jobDescription) = $event)),
                          class: "editable-description",
                          onChange: saveChanges
                        }, null, 544)), [
                          [_vModelText, application.value.jobDescription]
                        ])
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (application.value.jobDescription)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(application.value.jobDescription), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_54, "No job description provided"))
                        ], 64))
                  ])
                ])
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(aiTools, (tool) => {
              return _createElementVNode("div", {
                key: tool.name,
                class: _normalizeClass(["tool-card", { disabled: tool.disabled }]),
                onClick: tool.action
              }, [
                (tool.comingSoon)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_59, "Coming Soon"))
                  : _createCommentVNode("", true),
                (tool.isNew)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_60, "New"))
                  : _createCommentVNode("", true),
                _createElementVNode("i", {
                  class: _normalizeClass(tool.icon)
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(tool.name), 1)
              ], 10, _hoisted_58)
            }), 64))
          ])
        ]),
        (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              (matchAnalysis.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createVNode(JobMatchRadarChart, {
                      data: radarChartData.value,
                      compact: true,
                      style: {"height":"200px"}
                    }, null, 8, ["data"]),
                    _createElementVNode("div", { class: "analysis-actions" }, [
                      _createElementVNode("button", {
                        class: "analysis-btn",
                        onClick: openAdvancedAnalysis
                      }, [
                        _createTextVNode(" View Full Analysis "),
                        _hoisted_63
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _createElementVNode("div", { class: "splash-content" }, [
                      _hoisted_65,
                      _hoisted_66,
                      _createElementVNode("button", {
                        class: "analysis-btn",
                        onClick: openAdvancedAnalysis
                      }, [
                        _createTextVNode(" View Analysis "),
                        _hoisted_67
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})